module.exports = {
  cca: {
    view: 'modal',
    framework: 'cardinal',
    displayLoading: false
  },
  discoverWallet: {},
  paypal: {
    button: {
      style: 'paypal',
      shape: 'pill',
      color: 'blue',
      size: '26px'
    }
  },
  'paypal.braintree': {
    flow: 'checkout',
    intent: 'authorize',
    offerCredit: false,
    enableShippingAddress: true,
    shippingAddressEditable: true
  },
};


//////////////////
// WEBPACK FOOTER
// ./config/paymentBrandDefaultConfig.js
// module id = 28
// module chunks = 0 5 20